// @ts-nocheck
/* eslint-disable */ /* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */ import { ReactComponent as LogoProphecyWithName } from '../../../assets/images/Logos/logo-prophecy-with-name.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoProphecyWithNameIcon = /* @__PURE__ */ withLogoClass(LogoProphecyWithName);
